import api from '@/apis/di/currencyAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('currency', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_currency',
    field: {
      key: 'currency_id',
      code: 'currency_code',
      name: 'currency_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
